import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';

export const LocatorFeeder = ({ heading = 'Find this near you', blurb, therapies = [], testId = 'locator-feeder' }) => (
  <section className="border border-[#C7FA3E]/25 bg-[#C7FA3E]/[0.04] p-6 my-10" data-testid={testId}>
    <div className="flex items-center gap-2 mb-2">
      <MapPin className="w-4 h-4 text-[#C7FA3E]" />
      <h3 className="text-white text-2xl" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>{heading}</h3>
    </div>
    <p className="text-zinc-400 text-sm mb-4 max-w-2xl">
      {blurb || 'Our Recovery & Peptide Therapy Locator lists 540+ vetted facilities across 25 metros — with contact details and booking links.'}
    </p>
    <div className="flex flex-wrap gap-2">
      <Link to="/locator" className="inline-flex items-center gap-1.5 px-4 py-2 bg-[#C7FA3E] text-black text-xs font-bold uppercase tracking-widest hover:opacity-90 transition-opacity" style={{ fontFamily: 'Oswald, sans-serif' }} data-testid={`${testId}-main-cta`}>
        Open the Locator <ArrowRight className="w-3 h-3" />
      </Link>
      {therapies.map((t) => (
        <Link key={t.slug} to={`/locator/therapy/${t.slug}`} className="px-3 py-2 border border-zinc-700 text-zinc-300 hover:border-[#C7FA3E] hover:text-[#C7FA3E] text-xs uppercase tracking-wider transition-colors">
          {t.name} near you
        </Link>
      ))}
    </div>
  </section>
);

export default LocatorFeeder;
